(function () {
  if (window.KlaimQuickAddLab) return;

  var ROOT_SELECTOR = '[data-kqa-root]';
  var TRIGGER_SELECTOR = '[data-kqa-trigger]';
  var DESKTOP_QUERY = '(min-width: 992px)';

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function normalizeValue(value) {
    return String(value == null ? '' : value).trim().toLowerCase();
  }

  function imageKey(value) {
    return String(value || '').split('?')[0].replace(/^https?:/, '');
  }

  function money(cents) {
    var amount = Number(cents || 0) / 100;
    var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active
      ? window.Shopify.currency.active
      : 'EUR';
    var locale = document.documentElement.lang || 'nl-NL';
    var fractionDigits = Math.round(amount) === amount ? 0 : 2;

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits
      }).format(amount).replace(/\u00a0/g, ' ');
    } catch (error) {
      return 'EUR ' + amount.toFixed(fractionDigits);
    }
  }

  function applePayMark() {
    return '<span class="kqa__apple-pay-mark" aria-hidden="true">' +
      '<svg viewBox="18 27 130 55" role="presentation" focusable="false">' +
        '<path d="M43.508 35.77c1.404-1.755 2.356-4.112 2.105-6.52-2.054.102-4.56 1.355-6.012 3.112-1.303 1.504-2.456 3.959-2.156 6.266 2.306.2 4.61-1.152 6.063-2.858" />' +
        '<path d="M45.587 39.079c-3.35-.2-6.196 1.9-7.795 1.9-1.6 0-4.049-1.8-6.698-1.751-3.447.05-6.645 2-8.395 5.1-3.598 6.2-.95 15.4 2.55 20.45 1.699 2.5 3.747 5.25 6.445 5.151 2.55-.1 3.549-1.65 6.647-1.65 3.097 0 3.997 1.65 6.696 1.6 2.798-.05 4.548-2.5 6.247-5 1.95-2.85 2.747-5.6 2.797-5.75-.05-.05-5.396-2.101-5.446-8.251-.05-5.15 4.198-7.6 4.398-7.751-2.399-3.548-6.147-3.948-7.447-4.048" />' +
        '<path d="M78.973 32.11c7.278 0 12.347 5.017 12.347 12.321 0 7.33-5.173 12.373-12.529 12.373h-8.058V69.62h-5.822V32.11h14.062zm-8.24 19.807h6.68c5.07 0 7.954-2.729 7.954-7.46 0-4.73-2.885-7.434-7.928-7.434h-6.706v14.894z" />' +
        '<path d="M92.764 61.847c0-4.809 3.665-7.564 10.423-7.98l7.252-.442v-2.08c0-3.04-2.001-4.704-5.562-4.704-2.938 0-5.07 1.507-5.51 3.82h-5.252c.157-4.86 4.731-8.395 10.918-8.395 6.654 0 10.995 3.483 10.995 8.89v18.663h-5.38v-4.497h-.13c-1.534 2.937-4.914 4.782-8.579 4.782-5.406 0-9.175-3.222-9.175-8.057zm17.675-2.417v-2.106l-6.472.416c-3.64.234-5.536 1.585-5.536 3.95 0 2.288 1.975 3.77 5.068 3.77 3.95 0 6.94-2.522 6.94-6.03z" />' +
        '<path d="M120.975 79.652v-4.496c.364.051 1.247.103 1.715.103 2.573 0 4.029-1.09 4.913-3.899l.52-1.663-9.852-27.293h6.082l6.863 22.146h.13l6.862-22.146h5.927l-10.216 28.67c-2.34 6.577-5.017 8.735-10.683 8.735-.442 0-1.872-.052-2.261-.157z" />' +
      '</svg></span><span class="visually-hidden">Buy with Apple Pay</span>';
  }

  function colorValue(name) {
    var value = normalizeValue(name);
    var colors = {
      black: '#191918', white: '#ffffff', grey: '#8f8f8f', gray: '#8f8f8f',
      gunmetal: '#7a7c79', cream: '#eee7d3', beige: '#d8c6a5', brown: '#6b4937',
      fudge: '#68534d', orange: '#d96808', red: '#b42424', pink: '#e7a6ba',
      blue: '#31558f', navy: '#1c2637', green: '#446649', yellow: '#e0c450',
      purple: '#725585'
    };
    if (colors[value]) return colors[value];
    var key = Object.keys(colors).find(function (color) { return value.indexOf(color) !== -1; });
    if (key) return colors[key];
    var hash = 0;
    for (var index = 0; index < value.length; index += 1) hash = value.charCodeAt(index) + ((hash << 5) - hash);
    var channel = function (shift) { return 88 + ((hash >> shift) & 95); };
    return 'rgb(' + channel(0) + ',' + channel(8) + ',' + channel(16) + ')';
  }

  function findOptionIndex(product, pattern) {
    return (product.options || []).findIndex(function (option) {
      return pattern.test(normalizeValue(option.name));
    });
  }

  function mediaContainer(trigger) {
    return trigger.closest('.klaim-card__media, .card-media, .pgc__img-wrap, .pgc__media, .product-card__media, [data-product-card-media]') ||
      trigger.closest('.klaim-card, .card-product, .pgc__card, article, li');
  }

  function getFocusable(root) {
    return Array.from(root.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (element) {
      return element.getClientRects().length > 0 && element.getAttribute('aria-hidden') !== 'true';
    });
  }

  function QuickAddLab(root) {
    this.root = root;
    this.sheet = root.querySelector('[data-kqa-sheet]');
    this.content = root.querySelector('[data-kqa-content]');
    this.live = root.querySelector('[data-kqa-live]');
    this.notify = root.querySelector('[data-kqa-notify]');
    this.notifyForm = root.querySelector('[data-kqa-notify-form]');
    this.notifyEmail = root.querySelector('[data-kqa-notify-email]');
    this.notifyMessage = root.querySelector('[data-kqa-notify-message]');
    this.notifySubmit = root.querySelector('[data-kqa-notify-submit]');
    this.desktopMedia = window.matchMedia(DESKTOP_QUERY);
    this.cache = new Map();
    this.requestIndex = 0;
    this.abortController = null;
    this.activeTrigger = null;
    this.inlineTrigger = null;
    this.inlinePanel = null;
    this.mobileState = null;
    this.bundleState = null;
    this.inlineBundleState = null;
    this.notifyState = null;
    this.lockState = null;

    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onDocumentKeydown = this.onDocumentKeydown.bind(this);
    this.onRootClick = this.onRootClick.bind(this);
    this.onRootChange = this.onRootChange.bind(this);
    this.onRootKeydown = this.onRootKeydown.bind(this);
    this.onNotifySubmit = this.onNotifySubmit.bind(this);
    this.onBreakpointChange = this.onBreakpointChange.bind(this);

    document.addEventListener('click', this.onDocumentClick, true);
    document.addEventListener('keydown', this.onDocumentKeydown);
    root.addEventListener('click', this.onRootClick);
    root.addEventListener('change', this.onRootChange);
    root.addEventListener('keydown', this.onRootKeydown);
    this.notifyForm.addEventListener('submit', this.onNotifySubmit);
    this.desktopMedia.addEventListener('change', this.onBreakpointChange);
  }

  QuickAddLab.prototype.onDocumentClick = function (event) {
    var trigger = event.target.closest(TRIGGER_SELECTOR);
    if (trigger) {
      event.preventDefault();
      event.stopPropagation();
      this.open(trigger);
      return;
    }

    if (this.inlinePanel && !this.inlinePanel.contains(event.target)) this.closeInline();
  };

  QuickAddLab.prototype.onDocumentKeydown = function (event) {
    if (event.key === 'Escape' && this.inlinePanel) this.closeInline(true);
  };

  QuickAddLab.prototype.onBreakpointChange = function () {
    this.closeInline();
    this.closeSheet(false);
  };

  QuickAddLab.prototype.open = function (trigger) {
    if (trigger.dataset.kqaComponentBundle === 'true') {
      window.location.assign(trigger.dataset.productUrl);
      return;
    }
    if (this.desktopMedia.matches) this.openInline(trigger);
    else this.openSheet(trigger);
  };

  QuickAddLab.prototype.fragmentUrl = function (trigger) {
    var url = new URL(trigger.dataset.productUrl, window.location.origin);
    url.searchParams.set('view', this.root.dataset.kqaFragmentView || 'klaim-quick-add');
    return url.toString();
  };

  QuickAddLab.prototype.loadProduct = function (trigger) {
    var cacheKey = trigger.dataset.productHandle || trigger.dataset.productUrl;
    if (this.cache.has(cacheKey)) return Promise.resolve(this.cache.get(cacheKey));

    if (this.abortController) this.abortController.abort();
    this.abortController = new AbortController();

    return fetch(this.fragmentUrl(trigger), {
      headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' },
      signal: this.abortController.signal
    }).then(function (response) {
      if (!response.ok) throw new Error('Product options could not be loaded.');
      return response.text();
    }).then(function (html) {
      var documentNode = new DOMParser().parseFromString(html, 'text/html');
      var fragment = documentNode.querySelector('[data-kqa-fragment]');
      var jsonNode = fragment && fragment.querySelector('[data-kqa-product-json]');
      if (!fragment || !jsonNode) throw new Error('Product options are unavailable.');
      var data = {
        product: JSON.parse(jsonNode.textContent),
        paymentHtml: fragment.querySelector('[data-kqa-payment-source]')?.innerHTML || ''
      };
      this.cache.set(cacheKey, data);
      return data;
    }.bind(this));
  };

  QuickAddLab.prototype.openSheet = function (trigger) {
    this.closeInline();
    if (this.activeTrigger && this.activeTrigger !== trigger) {
      this.activeTrigger.removeAttribute('aria-expanded');
      this.activeTrigger.removeAttribute('aria-busy');
    }
    this.activeTrigger = trigger;
    this.requestIndex += 1;
    var requestIndex = this.requestIndex;

    trigger.setAttribute('aria-expanded', 'true');
    trigger.setAttribute('aria-busy', 'true');
    this.content.innerHTML = '<div class="kqa__loading" aria-label="Loading product options"><span class="kqa__loading-mark" aria-hidden="true"></span></div>';
    this.root.dataset.open = 'true';
    this.root.setAttribute('aria-hidden', 'false');
    this.lockPage();
    requestAnimationFrame(function () { this.sheet.focus({ preventScroll: true }); }.bind(this));

    this.loadProduct(trigger).then(function (data) {
      if (requestIndex !== this.requestIndex || this.desktopMedia.matches) return;
      trigger.removeAttribute('aria-busy');
      this.renderSheet(data);
    }.bind(this)).catch(function (error) {
      if (error.name === 'AbortError' || requestIndex !== this.requestIndex) return;
      trigger.removeAttribute('aria-busy');
      this.renderLoadError(error.message);
    }.bind(this));
  };

  QuickAddLab.prototype.renderLoadError = function (message) {
    this.content.innerHTML = '<div class="kqa__error-state"><div><p>' + escapeHtml(message) + '</p>' +
      '<button class="kqa__retry" type="button" data-kqa-retry>TRY AGAIN</button></div></div>';
  };

  QuickAddLab.prototype.createBundleState = function (product) {
    var bundle = product.bundle;
    if (!bundle || !bundle.products?.length || !bundle.tiers?.length) return null;
    var defaultProduct = bundle.products.find(function (item) { return item.handle === product.handle; }) || bundle.products[0];
    return {
      product: product,
      bundle: bundle,
      pack: Number(bundle.tiers[0].count || 1),
      defaultHandle: defaultProduct.handle,
      productPickerIndex: null,
      optionPickerIndex: null,
      optionPickerField: null,
      items: [this.createBundleItem(defaultProduct.handle)]
    };
  };

  QuickAddLab.prototype.createBundleItem = function (handle) {
    return { handle: handle, size: '', shirtSize: '', shortSize: '' };
  };

  QuickAddLab.prototype.bundleTier = function (state) {
    return state?.bundle.tiers.find(function (tier) { return Number(tier.count) === Number(state.pack); }) || null;
  };

  QuickAddLab.prototype.bundleProduct = function (state, handle) {
    return state?.bundle.products.find(function (product) { return product.handle === handle; }) || null;
  };

  QuickAddLab.prototype.bundleFieldValue = function (item, field) {
    if (field === 'shirt') return item.shirtSize;
    if (field === 'short') return item.shortSize;
    return item.size;
  };

  QuickAddLab.prototype.bundleFieldMarkup = function (state, item, field, index, label) {
    var selected = this.bundleFieldValue(item, field);
    var pickerOpen = Number(state.optionPickerIndex) === index && state.optionPickerField === field;
    var pickerId = 'kqa-bundle-options-' + state.product.id + '-' + index + '-' + field;
    var placeholder = field === 'shirt' ? 'SHIRT SIZE' : field === 'short' ? 'SHORTS SIZE' : 'SIZE';
    return '<div class="kqa-bundle__field' + (field === 'size' ? ' kqa-bundle__field--size' : '') + '">' +
      '<span>' + escapeHtml(label) + '</span>' +
      '<button class="kqa-bundle__option-toggle" type="button" data-kqa-bundle-option-toggle="' + field + '" ' +
        'data-kqa-bundle-index="' + index + '" data-selected="' + Boolean(selected) + '" aria-expanded="' + pickerOpen + '" aria-controls="' + pickerId + '">' +
        '<strong>' + escapeHtml(selected || placeholder) + '</strong><span aria-hidden="true">+</span>' +
      '</button>' +
    '</div>';
  };

  QuickAddLab.prototype.bundleOptionPickerMarkup = function (state, item, index) {
    var field = Number(state.optionPickerIndex) === index ? state.optionPickerField : null;
    if (!field) return '';
    var product = this.bundleProduct(state, item.handle);
    var selected = this.bundleFieldValue(item, field);
    var choices = [];
    var seen = new Map();
    (product?.variants || []).forEach(function (variant) {
      var key = normalizeValue(variant.size);
      if (!key) return;
      if (!seen.has(key)) {
        var choice = { size: variant.size, available: Boolean(variant.available) };
        seen.set(key, choice);
        choices.push(choice);
      } else if (variant.available) {
        seen.get(key).available = true;
      }
    });
    var title = field === 'shirt' ? 'CHOOSE SHIRT SIZE' : field === 'short' ? 'CHOOSE SHORTS SIZE' : 'CHOOSE SIZE';
    var pickerId = 'kqa-bundle-options-' + state.product.id + '-' + index + '-' + field;
    return '<div class="kqa-bundle__option-picker" id="' + pickerId + '">' +
      '<div class="kqa-bundle__option-picker-head"><strong>' + title + '</strong><span>' + choices.length + ' OPTIONS</span></div>' +
      '<div class="kqa-bundle__option-grid">' + choices.map(function (choice) {
        var isSelected = normalizeValue(choice.size) === normalizeValue(selected);
        return '<button class="kqa-bundle__option" type="button" data-kqa-bundle-option="' + escapeHtml(choice.size) + '" ' +
          'data-kqa-bundle-field="' + field + '" data-kqa-bundle-index="' + index + '" aria-pressed="' + isSelected + '" ' +
          (!choice.available ? 'disabled data-unavailable="true"' : '') + '>' +
          '<strong>' + escapeHtml(choice.size) + '</strong>' + (!choice.available ? '<span>SOLD OUT</span>' : '') +
        '</button>';
      }).join('') + '</div>' +
    '</div>';
  };

  QuickAddLab.prototype.bundleItemsMarkup = function (state) {
    return state.items.map(function (item, index) {
      var number = String(index + 1).padStart(2, '0');
      var product = this.bundleProduct(state, item.handle) || state.bundle.products[0];
      var pickerId = 'kqa-bundle-products-' + state.product.id + '-' + index;
      var pickerOpen = state.productPickerIndex !== null && Number(state.productPickerIndex) === index;
      var productOptions = state.bundle.products.map(function (option) {
        var selected = option.handle === item.handle;
        var image = option.image
          ? '<img src="' + escapeHtml(option.image) + '" alt="" width="180" height="180" loading="lazy">'
          : '<span class="kqa-bundle__product-placeholder" aria-hidden="true"></span>';
        return '<button class="kqa-bundle__product-option" type="button" data-kqa-bundle-product="' + escapeHtml(option.handle) + '" ' +
          'data-kqa-bundle-index="' + index + '" aria-pressed="' + selected + '">' +
          '<span class="kqa-bundle__product-option-media">' + image + '</span>' +
          '<span class="kqa-bundle__product-option-name">' + escapeHtml(option.label || option.title) + '</span>' +
        '</button>';
      }).join('');
      var selectedImage = product?.image
        ? '<img src="' + escapeHtml(product.image) + '" alt="" width="120" height="120" loading="lazy">'
        : '<span class="kqa-bundle__product-placeholder" aria-hidden="true"></span>';
      var sizeFields = state.bundle.type === 'essentials'
        ? this.bundleFieldMarkup(state, item, 'shirt', index, 'SHIRT') + this.bundleFieldMarkup(state, item, 'short', index, 'SHORTS')
        : this.bundleFieldMarkup(state, item, 'size', index, 'SIZE');

      return '<div class="kqa-bundle__item" data-kqa-bundle-item="' + index + '">' +
        '<div class="kqa-bundle__item-head"><strong>' + escapeHtml(state.bundle.item_label || 'ITEM') + ' ' + number + '</strong></div>' +
        '<div class="kqa-bundle__product-control">' +
          '<span class="kqa-bundle__field-label">' + (state.bundle.type === 'yeezy' ? 'COLOUR' : 'PRODUCT') + '</span>' +
          '<button class="kqa-bundle__product-toggle" type="button" data-kqa-bundle-product-toggle="' + index + '" aria-expanded="' + pickerOpen + '" aria-controls="' + pickerId + '">' +
            '<span class="kqa-bundle__product-toggle-media">' + selectedImage + '</span>' +
            '<strong>' + escapeHtml(product?.label || product?.title || 'Choose product') + '</strong>' +
            '<span>CHANGE</span>' +
          '</button>' +
          '<div class="kqa-bundle__product-picker" id="' + pickerId + '" data-open="' + pickerOpen + '" ' + (pickerOpen ? '' : 'hidden') + '>' +
            '<div class="kqa-bundle__product-picker-head"><strong>CHOOSE PRODUCT</strong><span>' + state.bundle.products.length + ' OPTIONS</span></div>' +
            '<div class="kqa-bundle__product-grid">' + productOptions + '</div>' +
          '</div>' +
        '</div>' +
        '<div class="kqa-bundle__fields">' +
          sizeFields +
        '</div>' +
        this.bundleOptionPickerMarkup(state, item, index) +
      '</div>';
    }.bind(this)).join('');
  };

  QuickAddLab.prototype.bundleControlsMarkup = function (state, inline) {
    var tier = this.bundleTier(state);
    var tiers = state.bundle.tiers.map(function (item) {
      var selected = Number(item.count) === Number(state.pack);
      return '<button class="kqa-bundle__tier" type="button" data-kqa-bundle-pack="' + item.count + '" aria-pressed="' + selected + '">' +
        '<span>' + escapeHtml(item.label) + '</span><strong>' + money(item.total) + '</strong>' +
      '</button>';
    }).join('');
    var action = inline
      ? '<button class="kqa-inline__bundle-add" type="button" data-kqa-inline-bundle-add><span data-kqa-add-label>SELECT OPTIONS</span><span data-kqa-add-price>' + money(tier?.total) + '</span></button>'
      : '<div class="kqa__actions">' +
          '<button class="kqa__action kqa__action--express" type="button" data-kqa-express aria-label="Buy bundle with Apple Pay">' + applePayMark() + '</button>' +
          '<button class="kqa__action kqa__action--cart" type="button" data-kqa-add><span data-kqa-add-label>SELECT OPTIONS</span><span data-kqa-add-price>' + money(tier?.total) + '</span></button>' +
        '</div>';

    return '<div class="kqa-bundle" data-kqa-bundle data-kqa-bundle-type="' + escapeHtml(state.bundle.type) + '">' +
      '<div class="kqa-bundle__tiers" data-kqa-bundle-tiers role="group" aria-label="Bundle quantity">' + tiers + '</div>' +
      '<div class="kqa-bundle__items" data-kqa-bundle-items>' + this.bundleItemsMarkup(state) + '</div>' +
      action +
      '<p class="kqa__message" data-kqa-message role="alert"></p>' +
    '</div>';
  };

  QuickAddLab.prototype.bundleComplete = function (state) {
    if (!state || state.items.length !== Number(state.pack)) return false;
    return state.items.every(function (item) {
      var product = this.bundleProduct(state, item.handle);
      if (!product) return false;
      var hasVariant = function (size) {
        return product.variants.some(function (variant) {
          return variant.available && normalizeValue(variant.size) === normalizeValue(size);
        });
      };
      return state.bundle.type === 'essentials'
        ? hasVariant(item.shirtSize) && hasVariant(item.shortSize)
        : hasVariant(item.size);
    }.bind(this));
  };

  QuickAddLab.prototype.updateBundleActions = function (scope, state) {
    if (!scope || !state) return;
    var complete = this.bundleComplete(state);
    var tier = this.bundleTier(state);
    scope.querySelectorAll('[data-kqa-bundle-pack]').forEach(function (button) {
      button.setAttribute('aria-pressed', String(Number(button.dataset.kqaBundlePack) === Number(state.pack)));
    });
    scope.querySelectorAll('[data-kqa-add-label]').forEach(function (label) {
      label.textContent = complete ? 'ADD BUNDLE' : 'SELECT OPTIONS';
    });
    scope.querySelectorAll('[data-kqa-add-price]').forEach(function (price) {
      price.textContent = money(tier?.total);
    });
  };

  QuickAddLab.prototype.setBundlePack = function (state, pack) {
    if (!state || !state.bundle.tiers.some(function (tier) { return Number(tier.count) === Number(pack); })) return;
    state.pack = Number(pack);
    state.productPickerIndex = null;
    state.optionPickerIndex = null;
    state.optionPickerField = null;
    state.items = state.items.slice(0, state.pack);
    while (state.items.length < state.pack) state.items.push(this.createBundleItem(state.defaultHandle));
  };

  QuickAddLab.prototype.toggleBundleProductPicker = function (state, index) {
    if (!state || !state.items[index]) return;
    state.optionPickerIndex = null;
    state.optionPickerField = null;
    state.productPickerIndex = state.productPickerIndex !== null && Number(state.productPickerIndex) === Number(index) ? null : Number(index);
  };

  QuickAddLab.prototype.toggleBundleOptionPicker = function (state, index, field) {
    if (!state || !state.items[index] || !['shirt', 'short', 'size'].includes(field)) return;
    var isOpen = Number(state.optionPickerIndex) === Number(index) && state.optionPickerField === field;
    state.productPickerIndex = null;
    state.optionPickerIndex = isOpen ? null : Number(index);
    state.optionPickerField = isOpen ? null : field;
  };

  QuickAddLab.prototype.chooseBundleOption = function (state, index, field, value) {
    var item = state?.items[index];
    var product = item ? this.bundleProduct(state, item.handle) : null;
    var variant = product?.variants.find(function (candidate) {
      return candidate.available && normalizeValue(candidate.size) === normalizeValue(value);
    });
    if (!item || !variant) return;
    if (field === 'shirt') item.shirtSize = variant.size;
    else if (field === 'short') item.shortSize = variant.size;
    else if (field === 'size') item.size = variant.size;
    else return;
    state.optionPickerIndex = null;
    state.optionPickerField = null;
  };

  QuickAddLab.prototype.chooseBundleProduct = function (state, index, handle) {
    var item = state?.items[index];
    if (!item || !this.bundleProduct(state, handle)) return;
    item.handle = handle;
    item.size = '';
    item.shirtSize = '';
    item.shortSize = '';
    state.productPickerIndex = null;
    state.optionPickerIndex = null;
    state.optionPickerField = null;
  };

  QuickAddLab.prototype.refreshMobileBundle = function () {
    var purchase = this.content.querySelector('.kqa__purchase');
    if (!purchase || !this.bundleState) return;
    purchase.innerHTML = this.bundleControlsMarkup(this.bundleState, false);
    this.updateBundleActions(purchase, this.bundleState);
  };

  QuickAddLab.prototype.renderSheet = function (data) {
    var product = data.product;
    if (product.componentBundle) {
      window.location.assign(product.url);
      return;
    }
    var sizeIndex = findOptionIndex(product, /size|maat/);
    var colorIndex = findOptionIndex(product, /color|colour|kleur/);
    var firstAvailable = product.variants.find(function (variant) { return variant.available; }) || product.variants[0] || null;
    var selectedColor = colorIndex >= 0 && firstAvailable ? firstAvailable.options[colorIndex] : null;
    var requiresSize = sizeIndex >= 0 && (product.options[sizeIndex]?.values || []).length > 1;
    var selectedVariant = requiresSize ? null : firstAvailable;
    var media = (product.media || []).length ? product.media : [];
    var progressScale = media.length > 1 ? 1 / media.length : 1;
    this.bundleState = this.createBundleState(product);

    this.mobileState = this.bundleState ? null : {
      data: data,
      product: product,
      sizeIndex: sizeIndex,
      colorIndex: colorIndex,
      selectedColor: selectedColor,
      selectedVariant: selectedVariant,
      requiresSize: requiresSize
    };

    var galleryItems = media.map(function (item, index) {
      return '<li class="kqa__gallery-slide" data-kqa-slide data-media-index="' + index + '">' +
        '<img src="' + escapeHtml(item.src) + '" alt="' + escapeHtml(item.alt || product.title) + '" loading="' + (index < 2 ? 'eager' : 'lazy') + '">' +
      '</li>';
    }).join('');

    if (!galleryItems) {
      galleryItems = '<li class="kqa__gallery-slide"><span class="visually-hidden">No product image available</span></li>';
    }

    var swatches = '';
    if (colorIndex >= 0 && product.options[colorIndex].values.length > 1) {
      swatches = '<div class="kqa__swatches" aria-label="Available colours">' + product.options[colorIndex].values.map(function (value) {
        return '<button class="kqa__swatch" type="button" data-kqa-color="' + escapeHtml(value) + '" ' +
          'style="--kqa-swatch:' + colorValue(value) + '" aria-label="' + escapeHtml(value) + '" aria-pressed="' +
          (normalizeValue(value) === normalizeValue(selectedColor) ? 'true' : 'false') + '"></button>';
      }).join('') + '</div>';
    }

    var purchaseHtml = this.bundleState
      ? this.bundleControlsMarkup(this.bundleState, false)
      : '<div class="kqa__selector-wrap" data-kqa-selector-wrap>' +
          '<button class="kqa__size-toggle" type="button" data-kqa-size-toggle aria-expanded="false"><span data-kqa-size-label>Size</span>' +
            '<svg viewBox="0 0 15 14" aria-hidden="true"><path d="M7.33 0v14M.5 7.17h14" /></svg>' +
          '</button>' +
          '<div class="kqa__variant-tray" data-kqa-variant-tray data-open="false"><ul class="kqa__variant-list" data-kqa-variant-list></ul></div>' +
        '</div>' +
        '<div class="kqa__actions">' +
          '<button class="kqa__action kqa__action--express" type="button" data-kqa-express aria-label="Buy with Apple Pay">' + applePayMark() + '</button>' +
          '<button class="kqa__action kqa__action--cart" type="button" data-kqa-add><span data-kqa-add-label>SELECT SIZE</span><span data-kqa-add-price></span></button>' +
        '</div>' +
        '<p class="kqa__message" data-kqa-message role="alert"></p>' +
        '<div class="kqa__native-payment" data-kqa-native-payment>' + data.paymentHtml + '</div>';

    this.content.innerHTML =
      '<div class="kqa-product" data-kqa-product data-bundle="' + Boolean(this.bundleState) + '">' +
        '<div class="kqa__media-shell">' +
          '<div class="kqa__gallery"><ul class="kqa__gallery-track" data-kqa-gallery>' + galleryItems + '</ul></div>' +
          swatches +
          '<div class="kqa__gallery-progress" role="progressbar" aria-label="Product images" aria-valuemin="1" aria-valuemax="' + Math.max(1, media.length) + '" aria-valuenow="1"><span class="kqa__gallery-progress-bar" data-kqa-progress style="--kqa-progress-scale:' + progressScale.toFixed(6) + '"></span></div>' +
        '</div>' +
        '<div class="kqa__meta">' +
          '<a class="kqa__title-link" id="KqaTitle" href="' + escapeHtml(product.url) + '"><span>' + escapeHtml(product.title) + '</span>' +
            '<svg viewBox="0 0 13 13" aria-hidden="true"><path d="M8.76 7.04H2.17V5.96h6.59L5.73 2.93l.77-.76 4.33 4.33-4.33 4.33-.77-.76 3.03-3.03Z" /></svg>' +
          '</a>' +
          '<div class="kqa__purchase">' +
            purchaseHtml +
          '</div>' +
        '</div>' +
      '</div>';

    if (this.bundleState) this.updateBundleActions(this.content, this.bundleState);
    else {
      this.renderMobileVariants();
      this.updateMobileSelection();
    }
    this.bindGalleryProgress();
    if (!this.bundleState) {
      window.setTimeout(function () {
        if (window.Shopify && Shopify.PaymentButton && typeof Shopify.PaymentButton.init === 'function') Shopify.PaymentButton.init();
      }, 0);
    }
  };

  QuickAddLab.prototype.mobileVariants = function () {
    var state = this.mobileState;
    if (!state) return [];
    var product = state.product;
    var priceVaries = new Set(product.variants.map(function (variant) { return Number(variant.price); })).size > 1;

    if (state.sizeIndex >= 0) {
      return product.options[state.sizeIndex].values.map(function (size) {
        var variant = product.variants.find(function (candidate) {
          var sizeMatches = normalizeValue(candidate.options[state.sizeIndex]) === normalizeValue(size);
          var colorMatches = state.colorIndex < 0 || normalizeValue(candidate.options[state.colorIndex]) === normalizeValue(state.selectedColor);
          return sizeMatches && colorMatches;
        });
        return { label: size, variant: variant || null, priceVaries: priceVaries };
      });
    }

    return product.variants.map(function (variant) {
      return {
        label: normalizeValue(variant.title) === 'default title' ? 'One size' : variant.title,
        variant: variant,
        priceVaries: priceVaries
      };
    });
  };

  QuickAddLab.prototype.renderMobileVariants = function () {
    var state = this.mobileState;
    var list = this.content.querySelector('[data-kqa-variant-list]');
    var tray = this.content.querySelector('[data-kqa-variant-tray]');
    if (!state || !list || !tray) return;

    var rows = this.mobileVariants();
    list.innerHTML = rows.map(function (row) {
      var variant = row.variant;
      var unavailable = !variant || !variant.available;
      var selected = variant && state.selectedVariant && String(variant.id) === String(state.selectedVariant.id);
      return '<li><button class="kqa__variant" type="button" data-kqa-variant-id="' + (variant ? variant.id : '') + '" data-unavailable="' + unavailable + '" aria-pressed="' + Boolean(selected) + '">' +
        '<span class="kqa__variant-name">' + escapeHtml(row.label) + '</span>' +
        (unavailable ? '<span class="kqa__variant-notify">Notify me</span>' : row.priceVaries ? '<span class="kqa__variant-price">' + money(variant.price) + '</span>' : '') +
      '</button></li>';
    }).join('');
    tray.style.setProperty('--kqa-variant-height', Math.min(rows.length * 36 + 8, 520) + 'px');
  };

  QuickAddLab.prototype.updateMobileSelection = function () {
    var state = this.mobileState;
    if (!state) return;
    var variant = state.selectedVariant;
    var label = this.content.querySelector('[data-kqa-size-label]');
    var add = this.content.querySelector('[data-kqa-add]');
    var express = this.content.querySelector('[data-kqa-express]');
    var addLabel = this.content.querySelector('[data-kqa-add-label]');
    var addPrice = this.content.querySelector('[data-kqa-add-price]');
    var paymentInput = this.content.querySelector('[data-kqa-payment-variant]');
    var rows = this.mobileVariants();

    if (label) {
      if (variant) {
        var selectedLabel = state.sizeIndex >= 0 ? variant.options[state.sizeIndex] : variant.title;
        label.textContent = normalizeValue(selectedLabel) === 'default title' ? 'One size' : 'Size ' + selectedLabel;
      } else {
        label.textContent = state.sizeIndex >= 0 ? 'Size' : 'Options';
      }
    }

    var available = Boolean(variant && variant.available);
    var anyAvailable = rows.some(function (row) { return row.variant && row.variant.available; });
    add.disabled = !available && !anyAvailable;
    add.setAttribute('aria-disabled', available || anyAvailable ? 'false' : 'true');
    express.disabled = !available && !anyAvailable;
    express.setAttribute('aria-disabled', available || anyAvailable ? 'false' : 'true');
    addLabel.textContent = available ? 'ADD TO CART' : anyAvailable ? 'SELECT SIZE' : 'SOLD OUT';
    addPrice.textContent = available ? money(variant.price) : '';
    if (paymentInput && variant) paymentInput.value = variant.id;
    this.content.querySelectorAll('[data-kqa-variant-id]').forEach(function (button) {
      var selected = variant && String(button.dataset.kqaVariantId) === String(variant.id);
      button.setAttribute('aria-pressed', String(Boolean(selected)));
    });
  };

  QuickAddLab.prototype.bindGalleryProgress = function () {
    var track = this.content.querySelector('[data-kqa-gallery]');
    var progress = this.content.querySelector('[data-kqa-progress]');
    if (!track || !progress) return;

    var slides = Array.from(track.querySelectorAll('[data-kqa-slide]'));
    var progressRoot = progress.parentElement;
    var measureFrame = 0;
    var motionFrame = 0;
    var targetScale = slides.length > 1 ? 1 / slides.length : 1;
    var renderedScale = targetScale;
    var velocity = 0;
    var previousTime = 0;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    var clamp = function (value, minimum, maximum) {
      return Math.max(minimum, Math.min(maximum, value));
    };

    var render = function (scale) {
      progress.style.setProperty('--kqa-progress-scale', clamp(scale, 0, 1).toFixed(6));
    };

    var animate = function (timestamp) {
      motionFrame = 0;
      if (!track.isConnected || !progress.isConnected) return;

      if (reducedMotion.matches) {
        renderedScale = targetScale;
        velocity = 0;
        previousTime = 0;
        render(renderedScale);
        return;
      }

      var deltaTime = previousTime ? Math.min((timestamp - previousTime) / 1000, 0.032) : (1 / 60);
      previousTime = timestamp;
      var acceleration = ((targetScale - renderedScale) * 170) - (velocity * 26);
      velocity += acceleration * deltaTime;
      renderedScale += velocity * deltaTime;

      if (Math.abs(targetScale - renderedScale) < 0.0001 && Math.abs(velocity) < 0.0001) {
        renderedScale = targetScale;
        velocity = 0;
        previousTime = 0;
        render(renderedScale);
        return;
      }

      render(renderedScale);
      motionFrame = window.requestAnimationFrame(animate);
    };

    var setTarget = function (scale, immediate) {
      targetScale = clamp(scale, 0, 1);
      if (immediate || reducedMotion.matches) {
        if (motionFrame) window.cancelAnimationFrame(motionFrame);
        motionFrame = 0;
        renderedScale = targetScale;
        velocity = 0;
        previousTime = 0;
        render(renderedScale);
        return;
      }
      if (!motionFrame) motionFrame = window.requestAnimationFrame(animate);
    };

    var update = function (immediate) {
      measureFrame = 0;
      var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      var position = maxScroll > 0 ? clamp(track.scrollLeft / maxScroll, 0, 1) : 1;
      var slideProgress = slides.length > 1 ? (1 + (position * (slides.length - 1))) / slides.length : 1;
      var activeIndex = slides.length > 1 ? Math.round(position * (slides.length - 1)) : 0;
      setTarget(slideProgress, immediate === true);
      if (progressRoot) progressRoot.setAttribute('aria-valuenow', String(activeIndex + 1));
    };

    var requestUpdate = function () {
      if (!measureFrame) measureFrame = window.requestAnimationFrame(update);
    };

    track.addEventListener('scroll', requestUpdate, { passive: true });
    track.addEventListener('scrollend', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    reducedMotion.addEventListener?.('change', requestUpdate);
    update(true);
  };

  QuickAddLab.prototype.onRootClick = function (event) {
    var close = event.target.closest('[data-kqa-close]');
    if (close) {
      event.preventDefault();
      this.closeSheet(true);
      return;
    }

    var notifyClose = event.target.closest('[data-kqa-notify-close]');
    if (notifyClose) {
      event.preventDefault();
      this.closeNotify(true);
      return;
    }

    var retry = event.target.closest('[data-kqa-retry]');
    if (retry && this.activeTrigger) {
      this.openSheet(this.activeTrigger);
      return;
    }

    var bundlePack = event.target.closest('[data-kqa-bundle-pack]');
    if (bundlePack && this.bundleState) {
      this.setBundlePack(this.bundleState, Number(bundlePack.dataset.kqaBundlePack));
      this.refreshMobileBundle();
      return;
    }

    var productToggle = event.target.closest('[data-kqa-bundle-product-toggle]');
    if (productToggle && this.bundleState) {
      this.toggleBundleProductPicker(this.bundleState, Number(productToggle.dataset.kqaBundleProductToggle));
      this.refreshMobileBundle();
      this.content.querySelector('[data-kqa-bundle-product-toggle="' + productToggle.dataset.kqaBundleProductToggle + '"]')?.focus({ preventScroll: true });
      return;
    }

    var productOption = event.target.closest('[data-kqa-bundle-product]');
    if (productOption && this.bundleState) {
      this.chooseBundleProduct(this.bundleState, Number(productOption.dataset.kqaBundleIndex), productOption.dataset.kqaBundleProduct);
      this.refreshMobileBundle();
      return;
    }

    var bundleOptionToggle = event.target.closest('[data-kqa-bundle-option-toggle]');
    if (bundleOptionToggle && this.bundleState) {
      this.toggleBundleOptionPicker(this.bundleState, Number(bundleOptionToggle.dataset.kqaBundleIndex), bundleOptionToggle.dataset.kqaBundleOptionToggle);
      this.refreshMobileBundle();
      this.content.querySelector('[data-kqa-bundle-option-toggle="' + bundleOptionToggle.dataset.kqaBundleOptionToggle + '"][data-kqa-bundle-index="' + bundleOptionToggle.dataset.kqaBundleIndex + '"]')?.focus({ preventScroll: true });
      return;
    }

    var bundleOption = event.target.closest('[data-kqa-bundle-option]');
    if (bundleOption && this.bundleState) {
      this.chooseBundleOption(this.bundleState, Number(bundleOption.dataset.kqaBundleIndex), bundleOption.dataset.kqaBundleField, bundleOption.dataset.kqaBundleOption);
      this.refreshMobileBundle();
      this.content.querySelector('[data-kqa-bundle-option-toggle="' + bundleOption.dataset.kqaBundleField + '"][data-kqa-bundle-index="' + bundleOption.dataset.kqaBundleIndex + '"]')?.focus({ preventScroll: true });
      return;
    }

    var toggle = event.target.closest('[data-kqa-size-toggle]');
    if (toggle) {
      this.toggleVariantTray();
      return;
    }

    var swatch = event.target.closest('[data-kqa-color]');
    if (swatch) {
      this.selectColor(swatch.dataset.kqaColor);
      return;
    }

    var variantButton = event.target.closest('[data-kqa-variant-id]');
    if (variantButton && variantButton.closest('[data-kqa-variant-list]')) {
      this.selectMobileVariant(variantButton);
      return;
    }

    if (event.target.closest('[data-kqa-add]')) {
      var addButton = event.target.closest('[data-kqa-add]');
      if (this.bundleState) this.handleBundleSubmit(this.bundleState, false, addButton, this.content);
      else if (this.mobileState?.selectedVariant) this.addToCart(this.mobileState.selectedVariant, false, addButton);
      else this.openVariantTray();
      return;
    }

    if (event.target.closest('[data-kqa-express]')) {
      var expressButton = event.target.closest('[data-kqa-express]');
      if (this.bundleState) this.handleBundleSubmit(this.bundleState, true, expressButton, this.content);
      else this.handleExpressPay(expressButton);
      return;
    }

    if (this.mobileState && !event.target.closest('[data-kqa-selector-wrap]')) this.closeVariantTray();
  };

  QuickAddLab.prototype.onRootChange = function () {};

  QuickAddLab.prototype.selectColor = function (value) {
    var state = this.mobileState;
    if (!state) return;
    state.selectedColor = value;
    this.content.querySelectorAll('[data-kqa-color]').forEach(function (swatch) {
      swatch.setAttribute('aria-pressed', normalizeValue(swatch.dataset.kqaColor) === normalizeValue(value) ? 'true' : 'false');
    });

    if (state.sizeIndex >= 0) state.selectedVariant = null;
    else state.selectedVariant = state.product.variants.find(function (variant) {
      return normalizeValue(variant.options[state.colorIndex]) === normalizeValue(value) && variant.available;
    }) || null;

    this.renderMobileVariants();
    this.updateMobileSelection();

    var featured = state.product.variants.find(function (variant) {
      return normalizeValue(variant.options[state.colorIndex]) === normalizeValue(value) && variant.featured_image;
    });
    if (featured) {
      var index = state.product.media.findIndex(function (item) { return imageKey(item.src) === imageKey(featured.featured_image); });
      var slide = index >= 0 ? this.content.querySelector('[data-media-index="' + index + '"]') : null;
      slide?.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    }
  };

  QuickAddLab.prototype.selectMobileVariant = function (button) {
    var state = this.mobileState;
    if (!state) return;
    var variant = state.product.variants.find(function (candidate) { return String(candidate.id) === String(button.dataset.kqaVariantId); });
    if (!variant || !variant.available) {
      this.openNotify(variant, state.product.title, button.querySelector('.kqa__variant-name')?.textContent || '');
      return;
    }
    state.selectedVariant = variant;
    this.closeVariantTray();
    this.updateMobileSelection();
    this.announce((state.sizeIndex >= 0 ? variant.options[state.sizeIndex] : variant.title) + ' selected');
  };

  QuickAddLab.prototype.toggleVariantTray = function () {
    var tray = this.content.querySelector('[data-kqa-variant-tray]');
    if (!tray) return;
    if (tray.dataset.open === 'true') this.closeVariantTray();
    else this.openVariantTray();
  };

  QuickAddLab.prototype.openVariantTray = function () {
    var tray = this.content.querySelector('[data-kqa-variant-tray]');
    var toggle = this.content.querySelector('[data-kqa-size-toggle]');
    if (!tray || !toggle) return;
    tray.dataset.open = 'true';
    toggle.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(function () {
      var selected = tray.querySelector('[aria-pressed="true"]');
      (selected || tray.querySelector('button:not([disabled])'))?.focus({ preventScroll: true });
      window.setTimeout(function () { selected?.scrollIntoView({ block: 'nearest' }); }, 310);
    });
  };

  QuickAddLab.prototype.closeVariantTray = function () {
    var tray = this.content.querySelector('[data-kqa-variant-tray]');
    var toggle = this.content.querySelector('[data-kqa-size-toggle]');
    if (tray) tray.dataset.open = 'false';
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  };

  QuickAddLab.prototype.handleExpressPay = function (button) {
    var variant = this.mobileState?.selectedVariant;
    if (!variant || !variant.available) {
      this.openVariantTray();
      return;
    }

    var dynamicButton = this.content.querySelector('.shopify-payment-button__button:not([disabled]), .shopify-payment-button__button--unbranded:not([disabled])');
    if (dynamicButton) {
      dynamicButton.click();
      return;
    }
    this.addToCart(variant, true, button);
  };

  QuickAddLab.prototype.openInline = function (trigger) {
    if (this.inlineTrigger === trigger && this.inlinePanel) {
      this.closeInline(true);
      return;
    }

    this.closeSheet(false);
    this.closeInline();
    var container = mediaContainer(trigger);
    if (!container) {
      window.location.assign(trigger.dataset.productUrl);
      return;
    }

    this.inlineTrigger = trigger;
    trigger.setAttribute('aria-expanded', 'true');
    trigger.setAttribute('aria-busy', 'true');
    var panel = document.createElement('div');
    panel.className = 'kqa-inline';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', 'Choose product options');
    panel.innerHTML = '<div class="kqa-inline__status"><span class="kqa__loading-mark" aria-hidden="true"></span></div>';
    container.appendChild(panel);
    this.inlinePanel = panel;
    requestAnimationFrame(function () { panel.dataset.open = 'true'; });

    var requestIndex = ++this.requestIndex;
    this.loadProduct(trigger).then(function (data) {
      if (requestIndex !== this.requestIndex || panel !== this.inlinePanel || !this.desktopMedia.matches) return;
      trigger.removeAttribute('aria-busy');
      this.renderInline(data);
    }.bind(this)).catch(function (error) {
      if (error.name === 'AbortError' || panel !== this.inlinePanel) return;
      trigger.removeAttribute('aria-busy');
      panel.innerHTML = '<div class="kqa-inline__status">' + escapeHtml(error.message) + '</div>';
    });
  };

  QuickAddLab.prototype.renderInline = function (data) {
    if (!this.inlinePanel) return;
    var product = data.product;
    if (product.componentBundle) {
      window.location.assign(product.url);
      return;
    }
    this.inlineBundleState = this.createBundleState(product);
    if (this.inlineBundleState) {
      this.renderInlineBundle();
      return;
    }
    var sizeIndex = findOptionIndex(product, /size|maat/);
    var priceVaries = new Set(product.variants.map(function (variant) { return Number(variant.price); })).size > 1;
    var rows = product.variants.map(function (variant) {
      var label = sizeIndex >= 0 ? variant.options[sizeIndex] : variant.title;
      if (normalizeValue(label) === 'default title') label = 'One size';
      return { variant: variant, label: label };
    });
    var seen = new Set();
    if (sizeIndex >= 0) {
      rows = rows.filter(function (row) {
        var key = normalizeValue(row.label);
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });
    }

    this.inlinePanel.innerHTML = '<ul class="kqa-inline__list">' + rows.map(function (row) {
      var variant = row.variant;
      return '<li><button class="kqa-inline__variant" type="button" data-kqa-inline-variant="' + variant.id + '" data-unavailable="' + (!variant.available) + '">' +
        '<span class="kqa-inline__name">' + escapeHtml(row.label) + '</span>' +
        (!variant.available ? '<span class="kqa-inline__notify">Notify me</span>' : priceVaries ? '<span class="kqa-inline__price">' + money(variant.price) + '</span>' : '') +
      '</button></li>';
    }).join('') + '</ul>';

    this.inlinePanel.addEventListener('click', function (event) {
      var button = event.target.closest('[data-kqa-inline-variant]');
      if (!button) return;
      event.preventDefault();
      var variant = product.variants.find(function (candidate) { return String(candidate.id) === String(button.dataset.kqaInlineVariant); });
      if (!variant || !variant.available) {
        this.openNotify(variant, product.title, button.querySelector('.kqa-inline__name')?.textContent || '');
        return;
      }
      this.addToCart(variant, false, button);
    }.bind(this));
    this.inlinePanel.querySelector('button')?.focus({ preventScroll: true });
  };

  QuickAddLab.prototype.renderInlineBundle = function () {
    var panel = this.inlinePanel;
    var state = this.inlineBundleState;
    if (!panel || !state) return;
    panel.innerHTML = this.bundleControlsMarkup(state, true);
    this.updateBundleActions(panel, state);

    panel.onclick = function (event) {
      var packButton = event.target.closest('[data-kqa-bundle-pack]');
      if (packButton) {
        event.preventDefault();
        this.setBundlePack(state, Number(packButton.dataset.kqaBundlePack));
        this.renderInlineBundle();
        return;
      }
      var productToggle = event.target.closest('[data-kqa-bundle-product-toggle]');
      if (productToggle) {
        event.preventDefault();
        this.toggleBundleProductPicker(state, Number(productToggle.dataset.kqaBundleProductToggle));
        this.renderInlineBundle();
        return;
      }
      var productOption = event.target.closest('[data-kqa-bundle-product]');
      if (productOption) {
        event.preventDefault();
        this.chooseBundleProduct(state, Number(productOption.dataset.kqaBundleIndex), productOption.dataset.kqaBundleProduct);
        this.renderInlineBundle();
        return;
      }
      var optionToggle = event.target.closest('[data-kqa-bundle-option-toggle]');
      if (optionToggle) {
        event.preventDefault();
        this.toggleBundleOptionPicker(state, Number(optionToggle.dataset.kqaBundleIndex), optionToggle.dataset.kqaBundleOptionToggle);
        this.renderInlineBundle();
        return;
      }
      var option = event.target.closest('[data-kqa-bundle-option]');
      if (option) {
        event.preventDefault();
        this.chooseBundleOption(state, Number(option.dataset.kqaBundleIndex), option.dataset.kqaBundleField, option.dataset.kqaBundleOption);
        this.renderInlineBundle();
        return;
      }
      var addButton = event.target.closest('[data-kqa-inline-bundle-add]');
      if (addButton) {
        event.preventDefault();
        this.handleBundleSubmit(state, false, addButton, panel);
      }
    }.bind(this);
  };

  QuickAddLab.prototype.closeInline = function (restoreFocus) {
    if (!this.inlinePanel) return;
    var panel = this.inlinePanel;
    var trigger = this.inlineTrigger;
    this.inlinePanel = null;
    this.inlineTrigger = null;
    this.inlineBundleState = null;
    panel.dataset.open = 'false';
    trigger?.removeAttribute('aria-expanded');
    trigger?.removeAttribute('aria-busy');
    window.setTimeout(function () { panel.remove(); }, 310);
    if (restoreFocus) trigger?.focus({ preventScroll: true });
  };

  QuickAddLab.prototype.bundleCartItems = function (state) {
    if (!this.bundleComplete(state)) return [];
    var pairCount = state.items.length;
    return state.items.map(function (item, index) {
      var product = this.bundleProduct(state, item.handle);
      var selectedSize = state.bundle.type === 'essentials' ? item.shirtSize : item.size;
      var variant = product.variants.find(function (candidate) {
        return candidate.available && normalizeValue(candidate.size) === normalizeValue(selectedSize);
      });
      var properties = state.bundle.type === 'essentials'
        ? {
            'Shirt size': item.shirtSize,
            'Short size': item.shortSize,
            '_klaim_essentials_set': 'true',
            '_klaim_set_product': product.title,
            '_klaim_bundle_item': String(index + 1)
          }
        : {
            '_Yeezy Slide bundle': pairCount + ' pair',
            '_Yeezy Slide bundle tier': pairCount === 3 ? '3+ pair' : pairCount + ' pair',
            '_Selected size': item.size,
            '_klaim_bundle_item': String(index + 1)
          };
      return { id: variant.id, quantity: 1, properties: properties };
    }.bind(this));
  };

  QuickAddLab.prototype.focusIncompleteBundle = function (scope) {
    var toggle = scope.querySelector('[data-kqa-bundle-option-toggle][data-selected="false"]');
    toggle?.focus({ preventScroll: true });
  };

  QuickAddLab.prototype.syncBundleDiscount = async function (type, sections, fallbackState) {
    var familyCodes = type === 'essentials' ? ['KLAIMSETS2', 'KLAIMSETS3'] : ['YEEZYSLIDE2', 'YEEZYSLIDE3'];
    var cartResponse = await fetch(window.routes?.cart_url ? window.routes.cart_url + '.js' : '/cart.js', {
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    });
    var cart = await cartResponse.json();
    if (!cartResponse.ok || cart.status) throw new Error(cart.description || 'The bundle price could not be checked.');

    var quantity = (cart.items || []).reduce(function (total, item) {
      var properties = item.properties || {};
      var belongs = type === 'essentials'
        ? properties._klaim_essentials_set === 'true'
        : Boolean(properties['_Yeezy Slide bundle']);
      return belongs ? total + Number(item.quantity || 0) : total;
    }, 0);
    var desiredCode = quantity >= 3 ? familyCodes[1] : quantity >= 2 ? familyCodes[0] : '';
    var retainedCodes = (cart.discount_codes || []).filter(function (discount) {
      return discount.applicable !== false && !familyCodes.includes(discount.code);
    }).map(function (discount) { return discount.code; });
    if (desiredCode) retainedCodes.push(desiredCode);

    var currentFamilyCode = (cart.discount_codes || []).find(function (discount) { return familyCodes.includes(discount.code); })?.code || '';
    if (currentFamilyCode === desiredCode && !sections.length) return fallbackState;
    if (!desiredCode && !currentFamilyCode) return fallbackState;

    var response = await fetch(window.routes?.cart_update_url || '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({
        discount: retainedCodes.join(','),
        sections: sections,
        sections_url: window.location.pathname
      })
    });
    var state = await response.json();
    if (!response.ok || state.status) throw new Error(state.description || 'The bundle price could not be applied.');
    return state;
  };

  QuickAddLab.prototype.handleBundleSubmit = async function (state, checkout, button, scope) {
    if (!state || button?.dataset.busy === 'true') return;
    if (!this.bundleComplete(state)) {
      this.focusIncompleteBundle(scope);
      return;
    }

    var items = this.bundleCartItems(state);
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var sections = cart && typeof cart.getSectionsToRender === 'function'
      ? cart.getSectionsToRender().map(function (section) { return section.id; })
      : [];
    var message = scope.querySelector('[data-kqa-message]');
    if (message) message.textContent = '';
    button.dataset.busy = 'true';
    button.setAttribute('aria-busy', 'true');
    button.disabled = true;
    cart?.setActiveElement?.(this.activeTrigger || this.inlineTrigger || button);

    try {
      var payload = { items: items };
      if (sections.length) {
        payload.sections = sections;
        payload.sections_url = window.location.pathname;
      }
      var response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(payload)
      });
      var addState = await response.json();
      if (!response.ok || addState.status) throw new Error(addState.description || 'One of these bundle options is no longer available.');

      var cartState = await this.syncBundleDiscount(state.bundle.type, sections, addState);
      this.announce('Bundle added to cart');
      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
          source: 'klaim-quick-add-bundle',
          productVariantId: String(items[0].id),
          cartData: cartState
        });
      }

      if (checkout) {
        window.location.assign('/checkout');
        return;
      }

      this.closeInline();
      this.closeSheet(false);
      if (cart && typeof cart.renderContents === 'function' && cartState.sections) cart.renderContents(cartState);
      else window.location.assign(window.routes?.cart_url || '/cart');
    } catch (error) {
      if (message) message.textContent = error.message || 'The bundle could not be added.';
      this.announce(error.message || 'The bundle could not be added.');
    } finally {
      button.removeAttribute('aria-busy');
      button.disabled = false;
      delete button.dataset.busy;
    }
  };

  QuickAddLab.prototype.addToCart = function (variant, checkout, button) {
    if (!variant || !variant.available || button?.dataset.busy === 'true') return;
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var formData = new FormData();
    formData.set('id', variant.id);
    formData.set('quantity', '1');
    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.set('sections', cart.getSectionsToRender().map(function (section) { return section.id; }).join(','));
      formData.set('sections_url', window.location.pathname);
      cart.setActiveElement?.(this.activeTrigger || this.inlineTrigger || button);
    }

    button.dataset.busy = 'true';
    button.setAttribute('aria-busy', 'true');
    this.setMessage('');

    fetch(window.routes?.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    }).then(function (response) {
      return response.json().then(function (json) {
        if (!response.ok || json.status) throw new Error(json.description || json.message || 'Could not add this item.');
        return json;
      });
    }).then(function (cartData) {
      this.announce('Added to cart');
      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
          source: 'klaim-quick-add-lab',
          productVariantId: String(variant.id),
          cartData: cartData
        });
      }

      if (checkout) {
        window.location.assign('/checkout');
        return;
      }

      this.closeInline();
      this.closeSheet(false);
      if (cart && typeof cart.renderContents === 'function') cart.renderContents(cartData);
      else window.location.assign(window.routes?.cart_url || '/cart');
    }.bind(this)).catch(function (error) {
      this.setMessage(error.message);
      this.announce(error.message);
    }.bind(this)).finally(function () {
      button.removeAttribute('aria-busy');
      delete button.dataset.busy;
    });
  };

  QuickAddLab.prototype.setMessage = function (message) {
    var node = this.content.querySelector('[data-kqa-message]');
    if (node) node.textContent = message || '';
    else if (message && this.inlinePanel) this.inlinePanel.insertAdjacentHTML('afterbegin', '<p class="kqa-inline__status">' + escapeHtml(message) + '</p>');
  };

  QuickAddLab.prototype.openNotify = function (variant, productTitle, optionLabel) {
    if (!variant) return;
    this.lockPage();
    this.notifyState = {
      variant: variant,
      restoreElement: document.activeElement
    };
    this.notify.querySelector('[data-kqa-notify-copy]').textContent = productTitle + ' - ' + optionLabel + ' is currently unavailable.';
    this.notifyMessage.hidden = true;
    this.notifyMessage.textContent = '';
    this.notifyForm.hidden = false;
    this.notifySubmit.disabled = false;
    this.notifySubmit.textContent = 'NOTIFY ME';
    this.notify.hidden = false;
    this.notify.setAttribute('aria-hidden', 'false');
    this.root.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () { this.notifyEmail.focus({ preventScroll: true }); }.bind(this));
  };

  QuickAddLab.prototype.closeNotify = function (restoreFocus) {
    if (this.notify.hidden) return;
    var restoreElement = this.notifyState?.restoreElement;
    this.notify.hidden = true;
    this.notify.setAttribute('aria-hidden', 'true');
    this.notifyState = null;
    if (this.root.dataset.open !== 'true') {
      this.root.setAttribute('aria-hidden', 'true');
      this.unlockPage();
    }
    if (restoreFocus) restoreElement?.focus({ preventScroll: true });
  };

  QuickAddLab.prototype.onNotifySubmit = function (event) {
    event.preventDefault();
    var email = this.notifyEmail.value.trim();
    var variant = this.notifyState?.variant;
    var companyId = this.root.dataset.kqaKlaviyoCompanyId;
    if (!email || !this.notifyEmail.checkValidity()) {
      this.notifyMessage.textContent = 'Enter a valid email address.';
      this.notifyMessage.hidden = false;
      this.notifyEmail.focus();
      return;
    }
    if (!variant || !companyId) return;

    this.notifySubmit.disabled = true;
    this.notifySubmit.textContent = 'SAVING...';
    this.notifyMessage.hidden = true;

    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      headers: {
        accept: 'application/vnd.api+json',
        'content-type': 'application/vnd.api+json',
        revision: '2026-07-15'
      },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variant.id } }
          }
        }
      })
    }).then(function (response) {
      if (!response.ok) throw new Error('The restock alert could not be saved.');
      this.notifyForm.hidden = true;
      this.notifyMessage.textContent = 'You are on the list. We will email you when this option returns.';
      this.notifyMessage.hidden = false;
      this.notify.querySelector('[data-kqa-notify-close]').focus();
    }.bind(this)).catch(function (error) {
      this.notifySubmit.disabled = false;
      this.notifySubmit.textContent = 'NOTIFY ME';
      this.notifyMessage.textContent = error.message;
      this.notifyMessage.hidden = false;
    }.bind(this));
  };

  QuickAddLab.prototype.onRootKeydown = function (event) {
    if (event.key === 'Escape') {
      if (!this.notify.hidden) this.closeNotify(true);
      else if (this.root.dataset.open === 'true') this.closeSheet(true);
      return;
    }

    if (event.key !== 'Tab') return;
    var scope = !this.notify.hidden ? this.notify.querySelector('.kqa-notify__panel') : this.sheet;
    var focusable = getFocusable(scope);
    if (!focusable.length) {
      event.preventDefault();
      scope.focus();
      return;
    }
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  QuickAddLab.prototype.lockPage = function () {
    if (this.lockState) return;
    var body = document.body;
    this.lockState = {
      scrollY: window.scrollY,
      position: body.style.position,
      top: body.style.top,
      width: body.style.width,
      overflow: body.style.overflow
    };
    document.documentElement.classList.add('kqa-page-locked');
    body.classList.add('kqa-page-locked');
    body.style.position = 'fixed';
    body.style.top = '-' + this.lockState.scrollY + 'px';
    body.style.width = '100%';
    body.style.overflow = 'hidden';
  };

  QuickAddLab.prototype.unlockPage = function () {
    if (!this.lockState) return;
    var body = document.body;
    var state = this.lockState;
    body.style.position = state.position;
    body.style.top = state.top;
    body.style.width = state.width;
    body.style.overflow = state.overflow;
    body.classList.remove('kqa-page-locked');
    document.documentElement.classList.remove('kqa-page-locked');
    this.lockState = null;
    window.scrollTo(0, state.scrollY);
  };

  QuickAddLab.prototype.closeSheet = function (restoreFocus) {
    if (this.root.dataset.open !== 'true') return;
    this.requestIndex += 1;
    this.abortController?.abort();
    this.abortController = null;
    this.closeVariantTray();
    this.closeNotify(false);
    this.root.dataset.open = 'false';
    this.root.setAttribute('aria-hidden', 'true');
    this.activeTrigger?.removeAttribute('aria-expanded');
    this.activeTrigger?.removeAttribute('aria-busy');
    this.unlockPage();
    var trigger = this.activeTrigger;
    this.activeTrigger = null;
    this.mobileState = null;
    this.bundleState = null;
    if (restoreFocus) trigger?.focus({ preventScroll: true });
  };

  QuickAddLab.prototype.announce = function (message) {
    this.live.textContent = '';
    requestAnimationFrame(function () { this.live.textContent = message; }.bind(this));
  };

  var root = document.querySelector(ROOT_SELECTOR);
  if (root) {
    window.KlaimQuickAddLab = new QuickAddLab(root);
    document.documentElement.dataset.klaimQuickAddRelease = 'flaneur-reference-v1';
  }
})();
